import { useTranslation } from 'react-i18next';
import { useStore } from '@stores/RootStore';
import { useRevokeScimToken, useActivateScimToken } from '@queryHooks/useScimToken';

export const useScimTokenToggle = (tenantId: string, tokenId: string) => {
  const { t } = useTranslation();
  const {
    uiStore: { alertStore, toastStore },
  } = useStore();

  const { mutate: revokeToken } = useRevokeScimToken();
  const { mutate: activateToken } = useActivateScimToken();

  const handleToggleStatus = (checked: boolean) => {
    const shouldActivateToken = checked;
    const mutationFn = shouldActivateToken ? activateToken : revokeToken;

    const dialogConfig = {
      title: t(shouldActivateToken ? 'ScimToken.revoke.activateTitle' : 'ScimToken.revoke.deactivateTitle'),
      message: t(shouldActivateToken ? 'ScimToken.revoke.activateMessage' : 'ScimToken.revoke.deactivateMessage'),
      successMessage: t(
        shouldActivateToken ? 'ScimToken.revoke.activateSuccess' : 'ScimToken.revoke.deactivateSuccess',
      ),
    };

    alertStore.open({
      type: 'success',
      title: dialogConfig.title,
      message: dialogConfig.message,
      useCancel: true,
      confirmName: t('ScimToken.revoke.confirm'),
      onConfirm: () => {
        mutationFn(
          { tenantId, tokenId },
          {
            onSuccess: () => {
              toastStore.open(dialogConfig.successMessage, 'bottom', 'center');
            },
            onError: () => {
              toastStore.open(t('ScimToken.revoke.fail'), 'bottom', 'center');
            },
          },
        );
      },
    });
  };

  return { handleToggleStatus };
};
